"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBHeroSection", {
  enumerable: true,
  get: function get() {
    return _SVBHeroSection.default;
  }
});
var _SVBHeroSection = _interopRequireDefault(require("./src/SVBHeroSection"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }